import type { Track } from "@similarweb/tracking-provider";

import type { SignalType } from "app/pages/sales-intelligence/domain/signals/types/signal";
import createTrackingEventName from "app/pages/sales-intelligence/utils/testing/createTrackingEventName";

export const createManageSignalsPageTrackingService = (track: Track) => {
    const trackManageSignalsPageEvent = (action: string, eventName: string, eventSubName: string) => {
        track("Signals Management", action, createTrackingEventName(eventName, eventSubName));
    };

    return {
        trackCustomizationToggle(isEnabled: boolean) {
            trackManageSignalsPageEvent(
                "enable customization toggle",
                "show signal customization",
                isEnabled ? "on" : "off",
            );
        },
        trackScrollToSignalTypeSection(signalType: SignalType) {
            trackManageSignalsPageEvent("Scroll to signal type section", "Signal type card", signalType);
        },
        trackOpenGuideLink(cardName: string) {
            trackManageSignalsPageEvent("User open link to guide", "Open guide", cardName);
        },
    };
};
